import { useContactFormStore } from './ContactFormStore';

export function useContactFormState() {
  const isOpen = useContactFormStore((state) => state.isOpen);
  const contactFormSlug = useContactFormStore((state) => state.contactFormSlug);
  const openContactForm = useContactFormStore((state) => state.openContactForm);
  const closeContactForm = useContactFormStore((state) => state.closeContactForm);

  return { isOpen, contactFormSlug, openContactForm, closeContactForm };
}
